<template>
  <!-- 薪酬发放（Ok保专属页） -->
  <div class="content main-container">
    <div class="info" ref="infoBox">
      <p>说明：</p>
      <p>1、在此页面可查看业务员每期结算单收入情况和历史提现记录。</p>
      <p>2、若用户是风控危险人员，有权限的用户可在此处进行账户冻结。</p>
    </div>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">业务员姓名/手机号</span>
        <Input v-model="searchParams.userNameOrPhone" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">结算主体</span>
        <Select v-model="searchParams.orgId" clearable filterable>
          <Option v-for="(item, i) in settlementEntityList" :key="i" :value="item.orgId" :label="item.settlementEntity"></Option>
        </Select>
      </div>
      <div v-if="searchParams.okbStatus == -1" class="input-item">
        <span class="label">提现类型</span>
        <Select v-model="searchParams.withdrawType" transfer placeholder="请选择销售状态" clearable>
          <Option value="1">银行卡</Option>
          <Option value="2">支付宝</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="error" @click="$refs.freezeAddModal.open()" v-if="$units.pointAction('offline_81_7_btn5')">新增冻结账户</Button>
        <Button type="warning" @click="exportTableData">导出明细</Button>
        <Button type="warning" v-if="$units.pointAction('offline_81_7_btn8')" @click="$refs.configSettingModalRef.open()">代开配置</Button>
      </div>  
    </div>

    <Tabs v-model="searchParams.okbStatus" @on-click="tabClick">
      <TabPane label="待发放" name="-2"></TabPane>
      <TabPane label="待提现" name="0"></TabPane>
      <TabPane label="待审核" name="3"></TabPane>
      <TabPane label="处理中" name="9"></TabPane>
      <TabPane label="提现失败" name="-1"></TabPane>
      <TabPane label="提现成功" name="1"></TabPane>
      <TabPane label="已冻结" name="99" v-if="$units.pointAction('offline_81_7_btn5')"></TabPane>
    </Tabs>
    <Tabs v-if="searchParams.okbStatus == 3" type="card" class="card-tabs" v-model="searchParams.invoiceConfig" @on-click="searchAjax">
      <TabPane label="大额打款" name="1"></TabPane>
      <TabPane label="开票打款" name="0"></TabPane>
    </Tabs>

    <div class="table-box">
      <loading :isShow="listLoading" />
      <div class="select-box">
        <Checkbox v-model="isAll" @on-change="changeIsAll">全选</Checkbox>
        <span>已选{{ selIds.length }}/{{ total }}项</span>
        <Button
          type="warning"
          @click="batchData"
          v-if="
            (searchParams.okbStatus == '-2' && $units.pointAction('offline_81_7_btn6')) ||
            (searchParams.okbStatus == '3' && $units.pointAction('offline_81_7_btn7'))
          "
          >批量操作</Button
        >
      </div>
      <Table
        :columns="columns"
        :data="tableData"
        row-key="key"
        ref="selection"
        @on-select-all-cancel="handleCancelSelectAll"
        @on-select-all="handleSelectAll"
        @on-select="handleSelect"
        @on-select-cancel="handleCancel"
      >
        <!-- 业务员姓名 -->
        <template slot-scope="{ row }" slot="userName">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>
        <!-- 状态 -->
        <template slot-scope="{ row }" slot="status">
          <div class="tag">
            <span v-if="row.okbStatus == '-2'" class="item not-started">待发放</span>
            <span v-else-if="row.okbStatus == '0'" class="item processing">待提现</span>
            <span v-else-if="row.okbStatus == '9'" class="item processing">银行处理中</span>
            <span v-else-if="row.okbStatus == '3'" class="item processing">待审核</span>
            <span v-else-if="row.okbStatus == '1'" class="item success">提现成功</span>
            <span v-else-if="[-1, 2].includes(row.okbStatus * 1)" class="item ended">提现失败</span>
            <span v-else-if="row.okbStatus == '99'" class="item ended">已冻结</span>
          </div>
        </template>
        <!-- 证件号 -->
        <template slot-scope="{ row }" slot="idNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
            <sensitiveView v-if="searchParams.okbStatus == -1" :data="row" queryKey="id" keyName="idNo" dataType="1" fun="49" />
            <sensitiveView v-else :data="row" queryKey="userId" keyName="idNo" dataType="1" fun="50" />
          </div>
        </template>
        <template slot-scope="{ row }" slot="alipayAccount">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.cardNo">
            <sensitiveView :data="row" queryKey="userId" keyName="alipayAccount" dataType="9" fun="50" />
          </div>
        </template>
        <!-- 银行卡号 -->
        <template slot-scope="{ row }" slot="cardNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.cardNo">
            <sensitiveView v-if="searchParams.okbStatus == -1" :data="row" queryKey="id" keyName="cardNo" dataType="3" fun="49" />
            <sensitiveView v-else :data="row" queryKey="userId" keyName="cardNo" dataType="3" fun="50" />
          </div>
        </template>
        <!-- 手机号 -->
        <template slot-scope="{ row }" slot="mobile">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.mobile">
            <sensitiveView v-if="searchParams.okbStatus == -1" :data="row" queryKey="id" keyName="mobile" dataType="2" fun="49" />
            <sensitiveView v-else :data="row" queryKey="userId" keyName="mobile" dataType="8" fun="50" />
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <!-- 转账失败 -->
          <!-- <div class="detail" v-if="row.status == '-1'">
            <span class="table-btn" @click="getDetailData(row)">重新付款</span>
          </div> -->
          <div class="detail">
            <template v-if="row.okbStatus == 3">
              <span class="table-btn" @click="$refs.checkStatusModalRef.open({ ...row, invoiceConfig: searchParams.invoiceConfig })">审核</span>
            </template>
            <template v-else>
              <span class="table-btn" @click="openDetail(row)">详情</span>
              <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip left-10" transfer v-if="searchParams.okbStatus == -1 && row.reason">
                <template>
                  <span class="table-btn red def">失败原因</span>
                  <div slot="content">
                    <p>{{ row.reason }}</p>
                  </div>
                </template>
              </Poptip>
              <span class="table-btn red" @click="$refs.freezeRemoveModal.open(row)" v-if="searchParams.okbStatus == 99">解除冻结</span>
              <span v-if="searchParams.okbStatus != 99" class="table-btn" @click="openWithdrawalList(row)">明细</span>
            </template>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>

    <!-- 详情 -->
    <detail-modal ref="detailModal" @reload="initList()" @submit="$refs.withdrawalList.open($event.data, $event.searchParams)" />
    <!-- 批量操作 -->
    <batch-modal ref="batchModal" @reload="initList()" />
    <!-- 明细 -->
    <withdrawal-list ref="withdrawalList" @reload="initList()" />
    <!-- 添加冻结账号 -->
    <freeze-add-modal ref="freezeAddModal" @reload="initList()" />
    <!-- 解除冻结账号 -->
    <freeze-remove-modal ref="freezeRemoveModal" @reload="initList()" />
    <!-- 待审核-审核 -->
    <checkStatusModal ref="checkStatusModalRef" @reload="initList()" />

    <configSettingModal ref="configSettingModalRef" />
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import withdrawalList from './components/withdrawalList';
import detailModal from './components/detailModal';
import batchModal from './components/batchModal';
import freezeAddModal from './components/freezeAddModal';
import freezeRemoveModal from './components/freezeRemoveModal';
import configSettingModal from './components/configSettingModal';
import checkStatusModal from './components/checkStatusModal';
import sensitiveView from '@/components/commons/sensitiveView';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';

export default {
  mixins: [config, pageTool, common],
  components: {
    withdrawalList,
    freezeAddModal,
    freezeRemoveModal,
    sensitiveView,
    batchModal,
    detailModal,
    confirmModal,
    checkStatusModal,
    configSettingModal
  },
  props: {},
  data() {
    return {
      settlementEntityList: [], // 结算主体
      allTableIds: [], // 所有的id
      allTableData: [], // 所有的数据
      selIds: [], //选择项
      isAll: false, //是否全选
      loading: false,
      searchParams: {
        invoiceConfig: '',
        okbStatus: '-2' // -2:待发放0:待提现9:银行处理中-1:提现失败1:提现成功99:已冻结
      }
    };
  },
  watch: {},
  computed: {},
  created() {
    this.queryOkSettlementEntity(); // 结算主体
    this.initListParams('/buz/userCashWithdrawLog/queryOkbPage');
  },
  activated() {
    this.initList();
  },
  methods: {
    initList() {
      this.getList();
      this.getAllList();
    },
    // 转化参数
    setListParams(params) {},
    listCallback(res) {
      res.data.forEach(item => {
        // 失败状态id唯一，非失败状态不存在id，以userId为主键
        item.mid = item.id || item.userId;
        item.key = Date.now() + item.mid;
        if (this.isAll || this.selIds.includes(item.mid)) {
          item._checked = true;
        }
      });
    },
    // 获取所有id
    async getAllList() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNo = 1;
      params.pageSize = 99999;
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkbPage',
        type: 'POST',
        data: params
      }).then(res => {
        this.allTableIds = [];
        res.data.forEach(item => {
          // 失败状态id唯一，非失败状态不存在id，以userId为主键
          item.mid = item.id || item.userId;
          this.allTableIds.push(item.mid);
        });
        this.allTableData = res.data;
      });
    },
    searchAjax() {
      this.listLoading = true;
      this.isAll = false;
      this.selIds = [];
      this.tableData = [];
      this.pageNum = 1;
      this.getAllList();
      this.getList();
    },
    // 明细
    openWithdrawalList(row) {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$refs.withdrawalList.open(row, params);
    },
    // 打开详情
    openDetail(row) {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$refs.detailModal.open(row, params);
    },
    // 批量操作
    batchData() {
      if (this.selIds.length == 0) {
        return this.$notice.error('您还没有选择批量操作的数据');
      }
      if (this.selIds.length > 10) {
        return this.$notice.error('批量操作最多勾选10条记录，请重新勾选');
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      let data = {
        userIds: [],
        reportIds: []
      };
      if (params.okbStatus == 3) {
        data = {
          userIds: [],
          idList: []
        };
      }
      // 提现失败状态特殊处理
      if (params.okbStatus == -1) {
        data = {
          idList: []
        };
      }
      let hasDisabled = false;
      let errorText = '';
      this.allTableData.forEach(item => {
        if (this.selIds.includes(item.mid)) {
          if (item.okbStatus == 99) {
            errorText = '您勾选了被冻结的业务员，请取消勾选后再操作';
            hasDisabled = true;
          }
          if (item.okbStatus == 2) {
            errorText = '您勾选了被驳回的提现记录，请取消勾选后再操作';
            hasDisabled = true;
          }
          if (params.okbStatus == 3) {
            data.idList = item.idStr.split(',');
            data.userIds.push(item.userId);
            data.okbStatus = 3;
          } else if (params.okbStatus == -1) {
            // 提现失败状态特殊处理
            data.idList.push(item.id);
          } else {
            data.userIds.push(item.userId);
            data.reportIds = data.reportIds.concat(item.reportIds);
          }
        }
      });
      if (hasDisabled) {
        this.$notice.error(errorText);
      } else {
        this.$refs.batchModal.open(data, params);
      }
    },
    // tab点击
    tabClick(val) {
      if (!this.searchParams.invoiceConfig && val == 3) {
        this.searchParams.invoiceConfig = '1';
      } else if (val != 3) {
        this.searchParams.invoiceConfig = '';
      }
      this.searchParams.withdrawType = '';
      this.$units.cancelhttpRequest();
      this.getColumns();
      this.searchAjax();
    },
    // 切换全选
    changeIsAll(val) {
      this.$refs.selection.selectAll(val);
      this.selIds = val ? JSON.parse(JSON.stringify(this.allTableIds)) : [];
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    // 取消全选
    handleCancelSelectAll(selection) {
      //从已选项中移除当页数据
      this.selIds = _.differenceBy(
        this.selIds,
        this.tableData.map(i => i.mid)
      );
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    // 全选
    handleSelectAll(selection) {
      //数组合并，有可能用户先选择了某几项，已经被我们push进去，因此数组合并需要去重一下
      let curSelIds = selection.map(i => i.mid);
      this.selIds = _.uniqBy(this.selIds.concat(curSelIds));
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    //选中单项
    handleSelect(selection, row) {
      console.log(row);
      //添加到已选项
      this.selIds.push(row.mid);
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    //取消选中单项
    handleCancel(selection, row) {
      //从已选项中去除取消项
      this.selIds = this.selIds.filter(mid => {
        return mid != row.mid;
      });
      _.remove(this.selIds, n => {
        return n === row.mid;
      });
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    // 导出
    exportTableData() {
      if (!this.$units.pointAction('offline_81_7_btn4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      if (this.selIds && this.selIds.length) {
        const list = this.allTableData.filter(item => this.selIds.includes(item.mid));
        params.userIds = list.map(item => item.userId);
      }
      this.$units.downloadFile('/buz/userCashWithdrawLog/exportOkbPage', params, 'POST');
    },
    // 获取结算主体
    queryOkSettlementEntity() {
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkSettlementEntity',
        type: 'GET',
        data: {}
      }).then(res => {
        if (res.data) {
          this.settlementEntityList = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  color: #727c8e;
  line-height: 1.8;
  overflow: hidden;
  position: relative;
}
.table-box {
  /deep/ .ivu-poptip {
    margin-left: 0 !important;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
/deep/ .tag {
  width: 100%;
  display: flex;
  justify-content: center;
  .item {
    min-width: 70px;
    padding: 0 7px;
    height: 24px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding-top: 1px;
  }
  .not-started {
    color: #238fff;
    background: #ebf5ff;
    border: 1px solid #b5daff;
  }
  .success {
    width: 72px;
    color: #35bf3f;
    background: #f6fcf4;
    border: 1px solid #abeaae;
  }
  .processing {
    color: #ff8900;
    background: #fff4e8;
    border: 1px solid #ffd4a5;
  }
  .ended {
    color: #e3461f;
    background: #fff5f2;
    border: 1px solid #ffc1b2;
  }
}
.select-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .ivu-btn {
    margin-left: auto;
  }
}
.card-tabs {
  /deep/.ivu-tabs-tab-active {
    &::before {
      background-color: transparent;
    }
  }
}
</style>